export enum TransportWarrantyActualArrivalSelectorMode {
  summary,
  edit,
}

export enum TransportWarrantyActualArrivalSelectorField {
  comments = 'comments',
  otherTransportType = 'otherTransportType',
  taxiSum = 'taxiSum',
  registrationNumber = 'registrationNumber',
  distance = 'distance',
  parkingFee = 'parkingFee',
  congestionTax = 'congestionTax',
  receiptSum = 'receiptSum',
  transportMode = 'transportMode',
  from = 'from',
  to = 'to',
}
